import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 text-slate-300 bg-slate-900" };
const _hoisted_2 = {
    id: "login",
    class: "admin-content min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8"
};
const _hoisted_3 = {
    href: "#main_content",
    name: "main_content",
    tabindex: "-1"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
    role: "main",
    class: "mt-8 px-6 sm:mx-auto sm:w-full sm:max-w-lg"
};
const _hoisted_6 = {
    key: 0,
    class: "bg-white py-8 px-4 shadow rounded-lg sm:px-10 text-slate-700 shadow-lg show"
};
const _hoisted_7 = {
    key: 0,
    class: "error-message mb-4"
};
const _hoisted_8 = { class: "text-sm text-slate-600" };
const _hoisted_9 = { class: "mt-2" };
const _hoisted_10 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_11 = {
    key: 1,
    class: "bg-white py-8 px-4 shadow rounded-lg sm:px-10 text-slate-700 shadow-lg show"
};
const _hoisted_12 = {
    key: 0,
    class: "error-message mb-4"
};
const _hoisted_13 = { class: "mt-2" };
const _hoisted_14 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_15 = {
    key: 2,
    class: "bg-white py-8 px-4 shadow rounded-lg sm:px-10 text-slate-700 shadow-lg show"
};
const _hoisted_16 = { class: "font-medium text-xl text-slate-900 mb-6" };
const _hoisted_17 = {
    key: 0,
    class: "error-message mb-4"
};
const _hoisted_18 = { class: "mt-2" };
const _hoisted_19 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_20 = { class: "mt-2" };
const _hoisted_21 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_22 = { class: "flex items-center justify-between" };
const _hoisted_23 = { class: "flex items-center" };
const _hoisted_24 = { class: "text-sm" };
const _hoisted_25 = { class: "text-sm text-center mt-6" };
const _hoisted_26 = ["href"];
const _hoisted_27 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
                _createElementVNode("img", {
                    src: _ctx.asset('img/logo.svg'),
                    alt: _ctx.app.name,
                    class: "mx-auto"
                }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("main", _hoisted_5, [
                (_ctx.authentication.mfa && _ctx.authentication.mfa_recovery === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "font-medium text-xl text-slate-900 mb-6" }, "Two Factor Authentication", -1)),
                        (_ctx.authentication.noFieldErrors())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.authentication.getErrorMessage()), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_8, [
                            _cache[9] || (_cache[9] = _createTextVNode(" Enter your Two Factor Authentication Token. Unable to access authentication device? Use a ", -1)),
                            _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.authentication.mfaRecovery()), ["prevent"]))
                            }, "recovery code"),
                            _cache[10] || (_cache[10] = _createTextVNode(". ", -1))
                        ]),
                        _createElementVNode("form", {
                            class: "admin-form space-y-6",
                            action: "#",
                            method: "post",
                            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.authentication.sendMfaCheck()), ["prevent"]))
                        }, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "code",
                                        name: "code",
                                        type: "text",
                                        maxlength: "6",
                                        autocomplete: "off",
                                        required: "",
                                        "aria-required": "true",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.authentication.data.code) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.authentication.data.code]
                                    ])
                                ]),
                                (_ctx.authentication.fieldHasErrors('code'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.authentication.getFieldError('code')), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "w-full"
                                }, "Submit")
                            ], -1))
                        ], 32)
                    ]))
                    : (_ctx.authentication.mfa && _ctx.authentication.mfa_recovery === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "font-medium text-xl text-slate-900 mb-6" }, "Two Factor Recovery", -1)),
                            (_ctx.authentication.noFieldErrors())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.authentication.getErrorMessage()), 1))
                                : _createCommentVNode("", true),
                            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-slate-600" }, " Enter a Two Factor Authentication Recovery Code. ", -1)),
                            _createElementVNode("form", {
                                class: "admin-form space-y-6",
                                action: "#",
                                method: "post",
                                onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.authentication.sendMfaCheck()), ["prevent"]))
                            }, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "recovery_code",
                                            name: "recovery_code",
                                            type: "text",
                                            autocomplete: "off",
                                            required: "",
                                            "aria-required": "true",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.authentication.data.recovery_code) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.authentication.data.recovery_code]
                                        ])
                                    ]),
                                    (_ctx.authentication.fieldHasErrors('recovery_code'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.authentication.getFieldError('recovery_code')), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "w-full"
                                    }, "Submit")
                                ], -1))
                            ], 32)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("h1", _hoisted_16, "Sign In to your " + _toDisplayString(_ctx.app.name) + " account", 1),
                            (_ctx.authentication.noFieldErrors())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.authentication.getErrorMessage()), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("form", {
                                class: "admin-form space-y-6",
                                action: "#",
                                method: "post",
                                onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.authentication.signIn()), ["prevent"]))
                            }, [
                                _createElementVNode("div", null, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "email" }, "Email address", -1)),
                                    _createElementVNode("div", _hoisted_18, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "email",
                                            name: "email",
                                            type: "email",
                                            autocomplete: "email",
                                            required: "",
                                            "aria-required": "true",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.authentication.data.email) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.authentication.data.email]
                                        ])
                                    ]),
                                    (_ctx.authentication.fieldHasErrors('email'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.authentication.getFieldError('email')), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "password" }, "Password", -1)),
                                    _createElementVNode("div", _hoisted_20, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "password",
                                            name: "password",
                                            type: "password",
                                            autocomplete: "current-password",
                                            required: "",
                                            "aria-required": "true",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.authentication.data.password) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.authentication.data.password]
                                        ])
                                    ]),
                                    (_ctx.authentication.fieldHasErrors('password'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.authentication.getFieldError('password')), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("nav", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "remember-me",
                                            name: "remember-me",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.authentication.data.remember) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.authentication.data.remember]
                                        ]),
                                        _cache[18] || (_cache[18] = _createElementVNode("label", {
                                            for: "remember-me",
                                            class: "ml-2 block text-sm text-slate-900"
                                        }, " Remember me ", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_component_router_link, { to: { name: 'recover' } }, {
                                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                    _createTextVNode(" Forgot your password? ", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "w-full"
                                    }, "Sign in")
                                ], -1))
                            ], 32)
                        ]))
            ]),
            _createElementVNode("footer", _hoisted_25, [
                _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.app.name) + " " + _toDisplayString(_ctx.app.version) + " © ", 1),
                    _createElementVNode("a", {
                        href: _ctx.app.copyright.url,
                        class: "alt",
                        target: "_blank"
                    }, _toDisplayString(_ctx.app.copyright.name), 9, _hoisted_26),
                    _cache[21] || (_cache[21] = _createTextVNode(". All rights reserved. ", -1))
                ]),
                _createElementVNode("p", null, [
                    _cache[22] || (_cache[22] = _createTextVNode(" Unauthorised access is not permitted. ", -1)),
                    _createElementVNode("a", {
                        href: _ctx.app.status_url,
                        class: "alt",
                        target: "_blank"
                    }, "System Status", 8, _hoisted_27)
                ])
            ])
        ])
    ]));
}
